<template>
  <div  class="index_container">
    <CustomButton size="small">小按钮</CustomButton>
    <CustomButton size="middle" round>中型按钮</CustomButton>
    <CustomButton size="large" round class="index_test">大型按钮</CustomButton>
  </div>
</template>
<script>
import CustomButton from '@/components/unit/CustomButton'
export default {
  name:'index',
  components:{
    CustomButton
  }
}
</script>
<style >
.index_container{
  height:100%;
  width:100%;
}
.index_test{
  width:50vw;
}
</style>